import React, { useEffect, useRef, useState } from "react";

const CODE_LENGTH = 6;

export default function CodeInputModal({ onCodeChange }) {
  const [code, setCode] = useState(Array(CODE_LENGTH).fill(""));
  const inputsRef = useRef([]);

  useEffect(() => {
    onCodeChange(code.join(""));
  }, [code, onCodeChange]);

  const handleChange = (event, index) => {
    const value = event.target.value;
    if (!/^\d?$/.test(value)) return;

    const nextCode = [...code];
    nextCode[index] = value;
    setCode(nextCode);

    if (value && index < CODE_LENGTH - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event) => {
    const digits = event.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, CODE_LENGTH);

    if (digits.length !== CODE_LENGTH) return;

    event.preventDefault();
    setCode(digits.split(""));
    inputsRef.current[CODE_LENGTH - 1]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center mt-4" onPaste={handlePaste}>
      {code.map((digit, index) => (
        <input
          key={index}
          ref={(element) => (inputsRef.current[index] = element)}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={1}
          value={digit}
          onChange={(event) => handleChange(event, index)}
          onKeyDown={(event) => handleKeyDown(event, index)}
          className="w-10 h-12 text-center text-xl border border-gray-400 rounded-xl p-2 mb-4"
        />
      ))}
    </div>
  );
}
